import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './Login';
import WorkerDashboard from './WorkerDashboard';
import CustomerDashboard from './CustomerDashboard';
import DashboardRedirect from './DashboardRedirect';
import Menuwahl from './Menuwahl';
import Inwil from './Inwil';
import Monatsauszug from './Monatsauszug';
import Header from './Header';
import RequireAuth from './RequireAuth';
import './App.css';

function App() {
  return (
    <Router>
      <Header />
      <div className="main-content fade-in">
        <Routes>
          <Route path="/" element={<Login />} />
          <Route element={<RequireAuth />}>
            <Route path="/worker-dashboard" element={<WorkerDashboard />} />
            <Route path="/customer-dashboard" element={<CustomerDashboard />} />
            <Route path="/dashboard-redirect" element={<DashboardRedirect />} />
            <Route path="/menuwahl" element={<Menuwahl />} />
            <Route path="/inwil" element={<Inwil />} />
            <Route path="/monatsauszug" element={<Monatsauszug />} />
          </Route>
        </Routes>
      </div>
    </Router>
  );
}

export default App;